<template>
  <div class="grid-x align-middle align-center">
    <div class="cell small-4 large-3">
      <div class="photo" :style="{ backgroundImage: `url(${photo.url})` }" />
    </div>
    <div class="cell small-6 large-5">
      <p class="text -t2">{{ name }}</p>
      <p class="text -t2">{{ role }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    photo: Object,
    name: String,
    role: String,
  },
};
</script>

<style lang="scss" scoped>
.photo {
  padding-top: 100%;
  border-radius: 50%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.text {
  text-align: left;
  margin-left: 0.5em;
  .-white & {
    color: #fff;
  }
}
</style>
